let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4wChI")).then(() => parcelRequire('fAnet'));